import React, { Component, createRef } from "react";
import { POST, loading, token, alert } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js"; 
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: ""
    };
  }
  componentDidMount() {
    loading(false);
  }
  render() {
    const {search} = this.state;
    return (
      <div className="w-100 min-vh-100 bg-dark position-relative">
        <Navbar />
        <div className="min-vh-100">
        <div className="mb-5 text-white">
         <div className="container py-5 text-center">
  <h2 className="fw-bold">ซื้อสินค้า Gift Shop</h2>
  <h5 className="mb-3">
    เลือกซื้อบัตรเติมเกม และบัตรเติมเงินออนไลน์ ได้ตลอด 24 ชม. กับ <b>SwiftGamePay</b>
  </h5>
  <small>
    แหล่งรวมบัตรเติมเกมและบัตรเติมเงินออนไลน์ มากกว่า 30 รายการ พร้อมให้บริการตลอด 24 ชม.
    สะดวก รวดเร็ว ปลอดภัย การันตียอดผู้ติดตามร้านกว่า 5 แสนซัพ
    มาพร้อมบริการชำระแบบผ่อนนานสูงสุดถึง 10 เดือน
    และพิเศษ! ซื้อสินค้ากับเรา รับเงินคืนและส่วนลดทันที
    โดย 1 coin = 1 บาท สามารถใช้แทนเงินสดได้
    พร้อมโปรโมชั่นสุดคุ้มตลอดทั้งเดือนและทั้งปี
    SwiftGamePay – No.1 เรื่องบัตรเติมเกมและบัตรเติมเงิน
  </small>
</div>

          </div>
        <div className="container mx-auto my-5">
          <div className="row">
            <div className="col-12 col-lg-3 mb-3">
              <div className="card p-3 bg-dark rounded-3" style={{border: "1px solid #494343"}}>
                <h5 className="fw-bold text-white mb-3">ตัวกรอง</h5>
                <input className="form-control" placeholder="ค้นหาสินค้า..." onChange={(e)=>{this.setState({search:e.target.value})}} value={search}></input>
              </div>
            </div>
            <div className="col-12 col-lg-9 text-center">
<h5 className="text-white">- ไม่มีรายการสินค้า โปรรอสินค้าเข้าระบบ -</h5>
            </div>
          </div>
        </div>
        </div>
        <Footer />
      </div>
    );
  }
}
